import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MatSnackBar } from '@angular/material/snack-bar';
import { dataService } from '../../services/data.service';
import { logbaseService } from '../../services/logbase.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { PfepService } from '../../services/pfepService';
import { RackEditData, NoubaEditData } from '../../models/pfepModels';
import { FormControl, Validators, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-modal-overview',
  templateUrl: './modal-overview.component.html',
  styleUrls: ['./modal-overview.component.scss']
})
export class ModalOverviewComponent implements OnInit {
  public editedRackCode: RackEditData = {
    rackCode: '',
      building: null,
      columnCount: null,
      drivingDirection: null,
      shelfCount: null,
      user: '',
      x: null,
      y: null,
      depth: '',
      width: '',
      height: ''
  };
  public editedNoubaCode: NoubaEditData = {
    noubaCode: '',
    building: null,
    drivingDirection: null,
    user: '',
    x: null,
    y: null,
    depth: null,
    width: null,
  };
  uploadConfirmation = false;
  noubaUploadError = false;
  rackUploadError = false;
  rackDataError = false;
  noubaDataError= false;
  rackUploadEntityErrors = [];
  noubaUploadEntityErrors = [];
  errorResponseMessage;
  rackEditingWindow = false;
  noubaEditingWindow = false;
  editNoubaSuccess = false;
  editRackSuccess = false;
  editRackError = false;
  editNoubaError = false;
  editRackErrorMessage = [];
  editNoubaErrorMessage = [];
  rackDataCopy;
  noubaDataCopy;
  rackBuildingCopy;
  noubaBuildingCopy;
  rackErrorMessage;
  noubaErrorMessage;
  // tslint:disable-next-line: max-line-length
  displayedRackColumns = ['rackCode', 'drivingDirection', 'x', 'y', 'depth', 'width', 'height', 'building', 'shelfCount', 'columnCount'];
  displayedNoubaColumns = ['noubaCode', 'drivingDirection', 'x', 'y', 'depth', 'width', 'building'];
  public editableRackCode = [];
  public editableNoubaCode = [];

// ****************Rack edit form validators*********************

  buildingNumberList = [];
  selectedBuildingNumber = new FormControl();
  rackCodeControl = new FormControl({value: '', disabled: true}, [Validators.required]);
  rackdrivingDirectionControl = new FormControl('', [Validators.required, Validators.pattern(/^-?(0|[0-9]\d*)?$/)]);
  rackXControl  = new FormControl('', [Validators.required, Validators.pattern(/^[0-9]\d*(\.\d+)?$/)]);
  rackYControl  = new FormControl('', [Validators.required, Validators.pattern(/^[0-9]\d*(\.\d+)?$/)]);
  rackDepthControl = new FormControl('', [Validators.required, Validators.pattern(/^[0-9]\d*(\.\d+)?$/)]);
  rackWidthControl = new FormControl('', [Validators.required, Validators.pattern(/^[0-9]\d*(\.\d+)?$/)]);
  rackHeightControl  = new FormControl('', [Validators.required, Validators.pattern(/^[0-9]\d*(\.\d+)?$/)]);
  rackShelfCountControl =  new FormControl('', [Validators.required, Validators.pattern(/^-?(0|[0-9]\d*)?$/)]);
  rackColumnCountControl = new FormControl('', [Validators.pattern(/^-?(0|[0-9]\d*)?$/)]);
  rackEditForm: FormGroup;

// ****************Nouba edit form validators*********************

  noubaCodeControl = new FormControl({value: '', disabled: true}, [Validators.required]);
  noubadrivingDirectionControl = new FormControl('', [Validators.required, Validators.pattern(/^-?(0|[0-9]\d*)?$/)]);
  noubaXControl  = new FormControl('', [Validators.required, Validators.pattern(/^[0-9]\d*(\.\d+)?$/)]);
  noubaYControl  = new FormControl('', [Validators.required, Validators.pattern(/^[0-9]\d*(\.\d+)?$/)]);
  noubaDepthControl = new FormControl('', [Validators.required, Validators.pattern(/^[0-9]\d*(\.\d+)?$/)]);
  noubaWidthControl = new FormControl('', [Validators.required, Validators.pattern(/^[0-9]\d*(\.\d+)?$/)]);
  noubaEditForm: FormGroup;

  public dataSource;
  constructor( public dialogRef: MatDialogRef<ModalOverviewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private spinner: NgxSpinnerService,
     private pfepService: PfepService, private translate: TranslateService, private snackBar: MatSnackBar) { }

  ngOnInit() {
    this.rackEditForm = new FormGroup({
      rackCode: this.rackCodeControl,
      drivingDirection: this.rackdrivingDirectionControl,
      x: this.rackXControl,
      y: this.rackYControl,
      depth: this.rackDepthControl,
      width: this.rackWidthControl,
      height: this.rackHeightControl,
      shelfCount: this.rackShelfCountControl,
      columnCount: this.rackColumnCountControl,
      building: this.selectedBuildingNumber
    });

    this.noubaEditForm = new FormGroup({
      noubaCode: this.noubaCodeControl,
      drivingDirection: this.noubadrivingDirectionControl,
      x: this.noubaXControl,
      y: this.noubaYControl,
      depth: this.noubaDepthControl,
      width: this.noubaWidthControl,
      building: this.selectedBuildingNumber
    });
    this.getBuildingNumbers();
   if (this.data.type === 'EditRack') {
    this.selectedBuildingNumber.setValue(this.data.rackData.building);
    this.rackBuildingCopy = this.data.rackData.building;
    this.editableRackCode.push(this.data.rackData);
    // this.rackDataCopy = [...this.data.rackData];
    this.rackDataCopy = Object.assign({}, this.data.rackData);
    this.dataSource = new MatTableDataSource(this.editableRackCode);
   }

   if (this.data.type === 'EditNouba') {
    this.selectedBuildingNumber.setValue(this.data.noubaData.building);
    this.noubaBuildingCopy = this.data.noubaData.building;
    this.editableNoubaCode.push(this.data.noubaData);
    this.noubaDataCopy = Object.assign({}, this.data.noubaData);
    this.dataSource = new MatTableDataSource(this.editableNoubaCode);
   }
  }
  getRequiredNumberErrorMessage(value) {
    return value.hasError('required') ? this.translate.instant('Required') :
        value.hasError('pattern') ? this.translate.instant('Only Numbers Allowed') :
            '';
  }
  getErrorMessage(value) {
      return  value.hasError('pattern') ? this.translate.instant('Only Numbers Allowed') :
            '';
  }
  getBuildingNumbers() {
    this.pfepService.getBuildingData().subscribe(response => {
      const buildingNumberArray = response.result;
      if (response.status && response.status.statusCode === 200) {
        this.buildingNumberList = [...this.buildingNumberList, ...buildingNumberArray];
      }
    });
  }
  onNoClick(): void {
    this.uploadConfirmation = false;
    this.rackEditingWindow = false;
    this.noubaEditingWindow = false;
    setTimeout(function(){
    }, 1000);
    this.dialogRef.close('updateData');
  }
  getEditMessage(type) {
    if (type === 'rack') {
      if (this.translate.currentLang === 'jn') {
        var text = this.translate.instant('Do you want to edit rack information for');
      return this.translate.instant(text.replace('/', ' '  +  "'" + this.data.rackData.rackCode + "'" + ' '));
      } else {
        var text = this.translate.instant('Do you want to edit rack information for');
        return text + ' ' +  "'" + this.data.rackData.rackCode + "'";
      }
    } else if (type === 'nouba') {
      if (this.translate.currentLang === 'jn') {
        var text = this.translate.instant('Do you want to edit nouba information for');
      return this.translate.instant(text.replace('/', ' '  +  "'" + this.data.noubaData.noubaCode + "'" + ' '));
      } else {
        var text = this.translate.instant('Do you want to edit nouba information for');
        return text + ' ' +  "'" + this.data.noubaData.noubaCode + "'";
      }
    }
    console.log(text, this.data.rackData.rackCode, this.translate.currentLang);

  }
  confirmUpload(type) {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    const formdata = new FormData();
    if (type === 'Nouba') {
      formdata.append('file', this.data.file);
      this.spinner.show();
      this.pfepService.noubaUploadFile(formdata, currentUser).subscribe(response => {
        if (response.status && response.status.statusCode === 200) {
          this.uploadConfirmation = true;
          this.spinner.hide();
        }
    }, error => {
      if (error.error.result && error.status === 415) {
       this.spinner.hide();
      this.uploadConfirmation = false;
      this.noubaUploadError = true;
      this.errorResponseMessage = error.error.result;
      }
      if (error.error.result && error.status === 422) {
        this.spinner.hide();
        this.uploadConfirmation = false;
        this.noubaUploadError = true;
        this.noubaDataError = true;
        this.noubaUploadEntityErrors = error.error.result;
        if (Array.isArray(error.error.result)) {
          this.noubaUploadEntityErrors = error.error.result;
        } else {
          this.spinner.hide();
          this.noubaErrorMessage = error.error.result;
        }
      }
    });
    } else {
      formdata.append('rack', this.data.file);
        this.spinner.show();
    this.pfepService.rackUploadFile(formdata, currentUser).subscribe(response => {

      if (response.status && response.status.statusCode === 200) {
        this.uploadConfirmation = true;
        this.spinner.hide();
      }
    }, error => {
      if (error.error.result && error.status === 415) {
        this.spinner.hide();
        this.uploadConfirmation = false;
        this.rackUploadError = true;
        this.errorResponseMessage = error.error.result;
      }
      if (error.error.result && error.status === 422) {
        this.spinner.hide();
        this.rackDataError = true;
        this.uploadConfirmation = false;
        this.rackUploadError = true;
        if (Array.isArray(error.error.result)) {
          this.rackUploadEntityErrors = error.error.result;
        } else {
          this.spinner.hide();
          this.rackErrorMessage = error.error.result;
        }
       }
    });
    }
  }
  confirmEditProcess() {
    this.rackEditingWindow = true;
    this.noubaEditingWindow = true;
  }
  confirmEdit(type) {
    if (type === 'EditRack') {
      if ((JSON.stringify(this.data.rackData) === JSON.stringify(this.rackDataCopy)) &&
      this.selectedBuildingNumber.value === this.rackBuildingCopy) {
      console.log('noraml copy', this.data.rackData, this.rackDataCopy );
        this.snackBar.open('Please Edit a field to update' , 'Ok', {
          duration: 3000,
          });
        return;
      }
      this.editedRackCode.rackCode = this.data.rackData.rackCode;
      // this.editedRackCode.building = this.data.rackData.building;
      this.editedRackCode.building = this.selectedBuildingNumber.value;
      this.editedRackCode.shelfCount = this.data.rackData.shelfCount;
      this.editedRackCode.columnCount = this.data.rackData.columnCount;
      this.editedRackCode.drivingDirection = this.data.rackData.drivingDirection;
      this.editedRackCode.x = this.data.rackData.x;
      this.editedRackCode.y = this.data.rackData.y;
      this.editedRackCode.depth = this.data.rackData.depth;
      this.editedRackCode.width = this.data.rackData.width;
      this.editedRackCode.height = this.data.rackData.height;
      this.editedRackCode.user = JSON.parse(localStorage.getItem('currentUser'));
      this.spinner.show();
      this.pfepService.updateRackDetails(this.editedRackCode).subscribe( result => {
        if (result.status && result.status.statusCode === 200) {
          this.spinner.hide();
          this.editRackSuccess = true;
        }
      }, error => {
        if (error.status === 422) {
          this.spinner.hide();
          this.editRackSuccess = false;
          this.editRackError = true;
          this.editRackErrorMessage = error.error.result;
        } else {
          this.spinner.hide();
        }
      });
    } else {
      if ((JSON.stringify(this.data.noubaData) === JSON.stringify(this.noubaDataCopy)) &&
      this.selectedBuildingNumber.value === this.noubaBuildingCopy ) {
        this.snackBar.open('Please Edit a field to update' , 'Ok', {
          duration: 3000,
          });
        return;
      }
      this.editedNoubaCode.noubaCode = this.data.noubaData.noubaCode;
      // this.editedNoubaCode.building = this.data.noubaData.building;
      this.editedNoubaCode.building = this.selectedBuildingNumber.value;
      this.editedNoubaCode.drivingDirection = this.data.noubaData.drivingDirection;
      this.editedNoubaCode.x = this.data.noubaData.x;
      this.editedNoubaCode.y = this.data.noubaData.y;
      this.editedNoubaCode.depth = this.data.noubaData.depth;
      this.editedNoubaCode.width = this.data.noubaData.width;
      this.editedNoubaCode.user = JSON.parse(localStorage.getItem('currentUser'));
      this.spinner.show();
      this.pfepService.updateNoubaDetails(this.editedNoubaCode).subscribe( result => {
        if (result.status && result.status.statusCode === 200) {
          this.spinner.hide();
          this.editNoubaSuccess = true;
        }
      }, error => {
        if (error.status === 422) {
          this.spinner.hide();
          this.editNoubaSuccess = false;
          this.editNoubaError = true;
          this.editNoubaErrorMessage = error.error.result;
        } else {
          this.spinner.hide();
        }
      });
    }
  }
  closePopup() {
    setTimeout(function(){
      this.uploadConfirmation = false;
    }, 1000);
    this.dialogRef.close('updateData');
  }
}
